<template>
  <div class="ms-office-wrapper">

    <!-- Sticky Navigation -->
    <div class="nav-container sticky-top">
      <nav class="modern-nav">
        <div 
          v-for="item in subPages" 
          :key="item.name"
          class="nav-item-wrapper"
        >
          <a
            href="#"
            class="modern-tab"
            :class="{ active: activePage === item.name }"
            :style="activePage === item.name ? { backgroundColor: item.color, borderColor: item.color } : {}"
            @click.prevent="goToSubPage(item)"
          >
            <span class="tab-text">{{ item.name }}</span>
          </a>
        </div>
      </nav>
    </div>

    <!-- Page Content -->
    <div class="container py-4">
      <div class="content-card">
        <transition name="fade-slide" mode="out-in">
          <keep-alive>
            <component :is="activeComponent" class="dynamic-component"></component>
          </keep-alive>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>
import MsOffice from "@/components/MSOffice/MsOffice.vue";
import MsWord from "@/components/MSOffice/MsWord.vue";
import MsExcel from "@/components/MSOffice/MsExcel.vue";
import MsPowerpoint from "@/components/MSOffice/MsPowerpoint.vue";
import MsAccess from "@/components/MSOffice/MsAccess.vue";

export default {
  name: "MsOfficePage",
  components: {
    MsOffice,
    MsWord,
    MsExcel,
    MsPowerpoint,
    MsAccess,
  },
  data() {
    return {
      subPages: [
        { name: "MS Office", component: "MsOffice", color: "#E04F2E" },
        { name: "MS Word", component: "MsWord", color: "#2B579A" },
        { name: "MS Powerpoint", component: "MsPowerpoint", color: "#B7472A" },
        { name: "MS Excel", component: "MsExcel", color: "#217346" },
        { name: "MS Access", component: "MsAccess", color: "#A4373A" },
      ],
      activePage: "MS Office",
    };
  },
  computed: {
    activeComponent() {
      const page = this.subPages.find(p => p.name === this.activePage);
      return page ? page.component : null;
    },
  },
  methods: {
    goToSubPage(page) {
      this.activePage = page.name;
    },
  },
};
</script>

<style scoped>
/* --- Page Background --- */
.ms-office-wrapper {
  background-color: #f4f6f8;
  min-height: 100vh;
  position: relative;
  padding-top: 12px; /* Space for fixed nav */
}

/* --- Fixed Navigation Bar --- */
.nav-container {
  position: sticky;
  top: 60px;
  left: 0;
  width: 100%;
  z-index: 2;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(0,0,0,0.05);
  padding: 1rem 0;
}

/* --- Modern Nav Row --- */
.modern-nav {
  display: flex;
  justify-content: center;
  gap: 12px;
  overflow-x: auto;
  padding: 0 1rem;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modern-nav::-webkit-scrollbar {
  display: none;
}

/* --- Individual Tabs --- */
.modern-tab {
  display: inline-flex;
  align-items: center;
  padding: 0.6rem 1.2rem;
  border-radius: 40px;
  text-decoration: none;
  font-weight: 500;
  color: #495057;
  background: #f1f3f5;
  border: 1px solid transparent;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.modern-tab:hover {
  background: #e9ecef;
  transform: translateY(-2px);
}

.modern-tab.active {
  color: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  transform: translateY(-3px);
}

/* --- Content Card --- */
.content-card {
  background: white;
  border-radius: 18px;
  padding: 2rem;
  box-shadow: 0 10px 25px rgba(0,0,0,0.06);
  min-height: 420px;
  transition: all 0.3s ease;
}

/* --- Page Transitions --- */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* --- Mobile Fixes --- */
@media (max-width: 768px) {
  .modern-nav {
    justify-content: flex-start;
  }

  .nav-item-wrapper:last-child {
    padding-right: 1rem;
  }

  .modern-tab {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }

  .content-card {
    padding: 1.3rem;
    border-radius: 14px;
  }
}

</style>
